import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Button from '../../components/Button';
import Dropdown from '../../components/Dropdown';
import Icon, { Icons } from '../../components/Icon/Icon';
import PageHeader from '../../components/PageHeader';
import t from '../../lang/t';
import HelperService from '../../services/HelperService';
import RequestService from '../../services/RequestService';
import StorageService from '../../services/StorageService';
import TypesService from '../../services/TypesService';
import DetailSheet from './components/DetailSheet';
import DetailStatus from './components/DetailsStatus/DetailStatus';

import ListItem from '../../components/ListItem';
import './TransactionDetails.scss';
import { TopUpPurpose } from '../TopUpCard/components/TopUpPurpose/TopUpPurpose';

const CurrenciesById = TypesService.CurrenciesById;

const mockFiatTransaction = {
	id: 'mock-fiat-1',
	type: 'fiat',
	Amount: -5.68,
	AmountUsd: 5.68,
	ReturnAmount: 5.68,
	Currency: 'USD',
	TransactionStatus: 3,
	merchantName: 'Silpo',

	SenderAddressesStr: 'TWwqDbsijbJTG5udd37AD3Uf7c3YxrjxDa',

	categoryId: 1,
	Created: '2025-12-17T07:53:00.520577Z',
	TxId: '45df8541f6dab290af8fcae8dfd60b07fdbabab621c89508ad6008d108e40653',
};

const TransactionDetails = () => {
	const [transactionDetails, setTransactionDetails] = useState(null);
	const [loading, setLoading] = useState(true);

	const currencies = useSelector(state => state.app.currencies);
	const isItTelegram = useSelector(state => state.app.isItTelegram);

	const location = useLocation();

	const prefix = loading ? '' : transactionDetails?.IsDeposit ? '+' : '-';

	const currencyData = CurrenciesById[transactionDetails?.CurrencyId];
	const feeCurrencyData =
		CurrenciesById[transactionDetails?.CommissionCurrencyId];

	const currency = transactionDetails
		? currencies.find(({ Id }) => Id === transactionDetails.CurrencyId)?.Symbol
		: '';
	const commissionCurrency = transactionDetails
		? currencies.find(
				({ Id }) => Id === transactionDetails.CommissionCurrencyId
		  )?.Symbol
		: '';

	const isFiatTransaction = false;
	const category = TypesService.getTransactionCategoryId(
		mockFiatTransaction?.categoryId
	);
	const fiatPrecision = TypesService.FiatPrecision;

	useEffect(() => {
		const GetTransactionDetail = async () => {
			const transaction = location.state?.transaction;

			if (transaction && transaction.Id) {
				const response = await RequestService.GetTransactionDetail(
					transaction.Id
				);
				if (response.Status === 'Success') {
					setTransactionDetails(response.TransactionDetail);
					// setTransactionDetails(mockFiatTransaction);
				}
			}

			setLoading(false);
		};

		GetTransactionDetail();
	}, []);

	console.log('transactionDetails?.TxId: ', transactionDetails);

	const shortAssetSymbol = currency ? currency.split('-')[0] : 'USD';

	useEffect(() => {
		StorageService.UpdateQuotes();
	}, []);

	return (
		<div className='TransactionDetails'>
			<PageHeader
				header={
					<>{`${transactionDetails?.Amount > 0 ? '+' : ''}${
						loading
							? 0
							: HelperService.FormatCrypto(
									transactionDetails?.Amount,
									isFiatTransaction ? fiatPrecision : currencyData?.Precision
							  )
					}
				${shortAssetSymbol}`}</>
				}
				subheader={
					<>{`${prefix}$${
						loading
							? 0
							: HelperService.FormatFiatWithoutCurrency(
									Math.abs(transactionDetails?.AmountUsd)
							  )
					}`}</>
				}
			/>
			<div
				className={classNames('TransactionDetails__content', {
					'offset-bottom': transactionDetails && transactionDetails.TxId,
				})}
			>
				{isFiatTransaction &&
					[3, 6, 10].includes(transactionDetails?.TransactionStatus) && (
						<div className='TransactionDetails__annotation'>
							<Icon type={Icons.CANCELED} width={32} height={32} />
							<p>
								Once the refund is processed, the funds go directly back to your
								card's available balance.
							</p>
						</div>
					)}

				{isFiatTransaction && (
					<div className='TransactionDetails__merchant FormBlock'>
						<ListItem
							icon={<Icon type={category.icon} width={32} height={32} />}
							title='Name'
							description={mockFiatTransaction.merchantName}
						/>
					</div>
				)}

				<DetailStatus
					statusId={transactionDetails?.TransactionStatus}
					isDeposit={transactionDetails?.IsDeposit}
				/>

				<TopUpPurpose
					showFiles
					comment={transactionDetails?.Comment}
					approvalFiles={transactionDetails?.AttachedFiles}
				/>

				{isFiatTransaction && (
					<div className='TransactionDetails__amount-block FormBlock'>
						<div
							className={`TransactionDetails__amount
								${
									transactionDetails?.TransactionStatus !== 2
										? 'TransactionDetails__amount__border'
										: ''
								}`}
						>
							<div className='TransactionDetails__amount-label'>
								{t('Amount_v2')}
							</div>
							<div className='TransactionDetails__amount-value'>
								-
								{HelperService.FormatCrypto(
									Math.abs(transactionDetails?.Amount),
									fiatPrecision
								)}{' '}
								USD
							</div>
						</div>
						{/*  */}
						{transactionDetails?.ReturnAmount && (
							<div className='TransactionDetails__fee'>
								<div className='TransactionDetails__fee-label'>
									{t('Return')}
								</div>
								<div className='TransactionDetails__fee-value'>
									+
									{HelperService.FormatCrypto(
										Math.abs(transactionDetails?.ReturnAmount),
										fiatPrecision
									)}{' '}
									USD
								</div>
							</div>
						)}
					</div>
				)}

				{!loading && !transactionDetails?.IsDeposit && !isFiatTransaction && (
					<div className='TransactionDetails__amount-block FormBlock'>
						<div className='TransactionDetails__amount TransactionDetails__amount__border'>
							<div className='TransactionDetails__amount-label'>
								{t('Amount_v2')}
							</div>
							<div className='TransactionDetails__amount-value'>
								{HelperService.FormatCrypto(
									Math.abs(transactionDetails?.Amount),
									currencyData?.Precision
								)}{' '}
								{shortAssetSymbol}
							</div>
						</div>
						<div className='TransactionDetails__fee'>
							<div className='TransactionDetails__fee-label'>
								{t('Network fee_v2')}
							</div>
							<div className='TransactionDetails__fee-value'>
								{HelperService.FormatCrypto(
									transactionDetails?.Commission,
									feeCurrencyData?.Precision
								)}{' '}
								{commissionCurrency}
							</div>
						</div>
					</div>
				)}

				{isFiatTransaction ? (
					<DetailSheet
						className={'DetailSheetBody'}
						currency={3}
						sender={transactionDetails?.SenderAddressesStr}
						recipient={transactionDetails?.DestinationAddress}
						date={
							transactionDetails?.NodeTime
								? transactionDetails?.NodeTime
								: transactionDetails?.Created
						}
						txId={transactionDetails?.TxId}
					/>
				) : (
					<Dropdown
						className='TransactionDetails_sheet'
						triggerTitle={t('Transaction details')}
						content={() => (
							<DetailSheet
								sender={transactionDetails?.SenderAddressesStr}
								recipient={transactionDetails?.DestinationAddress}
								date={
									transactionDetails?.NodeTime
										? transactionDetails?.NodeTime
										: transactionDetails?.Created
								}
								txId={transactionDetails?.TxId}
							/>
						)}
					/>
				)}

				<Button
					className='TransactionDetails__button'
					styleType='white'
					iconAfter={'ARROW_CHEVRON'}
					onClick={() =>
						isItTelegram
							? window.Telegram.WebApp.openLink(
									`${currencyData?.ScanLink}${transactionDetails.TxId}`
							  )
							: window.open(
									`${currencyData?.ScanLink}${transactionDetails.TxId}`,
									'_blank',
									'noopener,noreferrer'
							  )
					}
				>
					<div className='TransactionDetails__button-content'>
						<Icon type={Icons.NETWORK} width={24} height={24} />
						{t('View on block explorer')}
					</div>
				</Button>
			</div>
		</div>
	);
};

export default TransactionDetails;
